import $ from 'jquery';
import { __ } from '@wordpress/i18n';
import Header from './Header';
export default class MainMenu {
    static mount() {
        $(function () {
            new MainMenu();
        });
    }
    constructor() {
        this.$elements = $('nav');
        this.registerEvents();
        this.insertBackLinks();
    }
    insertBackLinks() {
        const $menus = this.$elements.find('.wp-block-navigation__submenu-container');
        const labelBack = __('< zurück', 'intas');
        const labelOverview = __('Übersicht', 'intas');
        const ariallabel = __('zurück zur übergeordneten Menüebene', 'intas');
        $menus.each(function () {
            const $menu = $(this);
            const $parentLi = $menu.parents('.wp-block-navigation-item');
            const $parentA = $('> a', $parentLi[0]);
            const href = $parentA.attr("href");
            const parentName = $parentA.text();
            const $parentLink = $('<li class="wp-block-navigation-item wp-block-navigation-link parent-link">' + parentName + '</li>');
            if (href) {
                const $parentOverviewLink = $('<li class="wp-block-navigation-item only-mobile wp-block-navigation-link"><a class="wp-block-navigation-item__content" href="' + href + '" aria-current="page"><span class="wp-block-navigation-item__label">' + labelOverview + '</span></a></li>');
                $menu.prepend($parentOverviewLink);
            }
            $menu.prepend($parentLink);
            $menu.prepend($("<li class='menu-back-button' aria-label='" + ariallabel + "'>" + labelBack + "</li>"));
        });
    }
    registerEvents() {
        const $toggleButton = this.$elements.find('.wp-block-navigation__responsive-container-open');
        $toggleButton.on('click', (event) => {
            if (event.currentTarget === null)
                return;
            const $button = $(event.currentTarget);
            this.onToggleClick($button);
        });
        const that = this;
        const $menus = this.$elements.find('.wp-block-navigation__container, .wp-block-navigation-submenu');
        $menus.each(function () {
            that.buildDelayedHover($(this));
        });
        const context = this.$elements.find('> .wp-block-navigation__responsive-container');
        context.on('click', (event) => this.contextClick(event));
    }
    contextClick(event) {
        if (event.currentTarget === null)
            return;
        const $nav = $(event.currentTarget).parents('nav');
        const $button = $('.wp-block-navigation__responsive-container-open', $nav);
        this.onToggleClick($button);
    }
    buildDelayedHover($menu) {
        const $menuItems = $("li", $menu);
        let that = this;
        $menu.on('click', function (event) {
            that.backLinkCheck(event);
        });
        $("> li.has-child", $menu).on('click', function (event) {
            if (Header.isMobileVariantMenu()) {
                const $target = $(event.target);
                if ($target.hasClass('has-child') || $target.parent().hasClass('has-child')) {
                    event.preventDefault();
                    event.stopPropagation();
                    that.makeMenuVisible($(this));
                }
            }
        });
        $menuItems.on('mouseenter', function () {
            if (!Header.isMobileVariantMenu()) {
                that.makeMenuVisible($(this));
            }
        });
        $menuItems.on('mouseleave', function () {
            if (!Header.isMobileVariantMenu()) {
                that.hideMenu($(this));
            }
        });
    }
    backLinkCheck(event) {
        const $currentTarget = $(event.currentTarget);
        if ($currentTarget.hasClass('submenu-open'))
            return;
        event.stopPropagation();
        this.hideMenu($($currentTarget.parents('li.submenu-open')[0]));
    }
    hideMenu($menuItem) {
        clearTimeout($menuItem.data("mouseleavetimer"));
        let parentUl = $menuItem.parent();
        $menuItem.data("mouseleavetimer", setTimeout(function () {
            $menuItem.removeClass('submenu-open');
            let openItems = $('> li.submenu-open', parentUl);
            if (openItems.length == 0) {
                parentUl.removeClass('has-opened-submenu');
            }
        }, 200));
    }
    makeMenuVisible($menuItem) {
        clearTimeout($menuItem.data("mouseleavetimer"));
        $menuItem.addClass('submenu-open');
        let parentUl = $menuItem.parent();
        parentUl.addClass('has-opened-submenu');
        let $parentLi = $menuItem.parents('li');
        if ($parentLi.length > 0) {
            this.makeMenuVisible($($parentLi[0]));
        }
    }
    onToggleClick($button) {
        const $parent = $button.parent();
        const $menu = $('.wp-block-navigation__responsive-container', $parent);
        $('.submenu-open', this.$elements).removeClass('submenu-open');
        $('.has-opened-submenu', this.$elements).removeClass('has-opened-submenu');
        if ($menu.hasClass('is-menu-open')) {
            $menu.removeClass('has-modal-open');
            $menu.removeClass('is-menu-open');
            $button.removeClass('is-menu-open');
            $('html').removeClass('has-modal-open');
        }
        else {
            $menu.addClass('has-modal-open');
            $menu.addClass('is-menu-open');
            $button.addClass('is-menu-open');
            $('html').addClass('has-modal-open');
        }
    }
}
